import React from 'react';
import AppLayout from '../../../component/appLayout';

const ProjectTimeline: React.FC = () => {
  return (
    <>
      <AppLayout>
        <div>This is project_timeline content</div>
      </AppLayout>
    </>
  );
};

export default ProjectTimeline;
